import React from 'react';
import { TopHeaderText } from '../../../constants/texts';
import { TopHeaderContainer, TopHeaderInner, TopHeaderContacts, TopHeaderNav, Linkto, PhoneLink } from './style';
const TopHeader = (props) => {
    return (
        <TopHeaderContainer>
            <div className="container">
                <TopHeaderInner>
                    <TopHeaderContacts>
                        <PhoneLink className="p-0" href={`tel:${props.storeInformation.phone}`}><i className="fas fa-phone mr-2"></i>{props.storeInformation.phone}</PhoneLink>
                        <PhoneLink style={{marginLeft: 10}} className="p-0" href={'#'} onClick={() => props.showSelectStore(true)}><i className="fas ml-12 fa-building mr-2"></i>{sessionStorage.getItem('currentSite') ? JSON.parse(sessionStorage.getItem('currentSite')).name : ''}{' '}<i className="fas fa-sync"/></PhoneLink>
                    </TopHeaderContacts>
                    <TopHeaderNav>
                        <Linkto className="header-cta" to="/products">{props.storeInformation.enableCommande ? TopHeaderText.BUTTON_TEXT : TopHeaderText.SEE_CATALOG}</Linkto>
                    </TopHeaderNav>
                </TopHeaderInner>
            </div>
        </TopHeaderContainer>
    )
}

export default TopHeader
